module.exports = __webpack_public_path__ + "img/2.a09dad92.svg";